// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XTOzm","text":"styles_text__Rp_j3"};